import React, { useState } from "react";
import useInventoryBin from "../../../utils/hooks/inventory/inventoryBin";
import BinInfo from "./BinInfo";
import InfoIcon from "../../common/FlashPCBTooltip/InfoIcon";
import FlashPCBTooltip from "../../common/FlashPCBTooltip";
import Modal from "../../common/Modal";
import ModalContentWithCloseButton from "../../common/ModalContentWithCloseButton";
import { FakeLink } from "../../../constants/Styles";
import { useCustomConfirm } from "../../../utils/hooks/alerts";
import LoadingIcon from "../../common/LoadingIcon";
import { InventoryBin } from "../parts/Bins/inventoryBinTypes";
import { useRemoveBoardPanelAssociation } from "../../../utils/hooks/commonly-stored/uploaded-board/updates/board";
import AddOrUpdateInventoryItem from "../parts/AddOrUpdateInventoryItem";
import {
  InventoryItem,
  InventoryItemType,
} from "../../../utils/hooks/inventory/useInventoryItems";
import { ItemLocationDetails, VerticalList } from "./BoardInventoryStyles";

export default function PanelInfo({
  panel,
  boardBin,
  boardId,
  onUpdate,
}: {
  panel: InventoryItem;
  boardBin: InventoryBin | null;
  boardId: string;
  onUpdate: () => void;
}) {
  const { inventoryBin, cannotFindBin, isLoading } = useInventoryBin(
    panel.flashpcb_bin_barcode,
  );
  const { removePanelFromBoard } = useRemoveBoardPanelAssociation();

  const handleDisassociatePanel = () => {
    customConfirm(
      "Are you sure you want to disassociate these panels from the project?",
      () => {
        removePanelFromBoard(boardId, { panel_ids: [panel.id] });
      },
    );
  };
  const [updatePanel, setUpdatePanel] = useState<boolean>(false);
  const customConfirm = useCustomConfirm();
  const closeModal = () => {
    setUpdatePanel(false);
  };

  const onSuccessfullyUpdatedPanel = () => {
    closeModal();
    onUpdate();
  };

  const panelHeader =
    panel.panel_item_details &&
    `${panel.last_counted_amount} ${panel.panel_item_details.boards_per_panel}-board panels (${panel.flashpcb_container_barcode}) `;
  const panelActions = (
    <>
      <FakeLink onClick={() => setUpdatePanel(true)}>Update</FakeLink>
      <FakeLink onClick={handleDisassociatePanel}>
        Disassociate panel(s) from project
      </FakeLink>
    </>
  );

  if (panel.flashpcb_bin_barcode !== null && isLoading) {
    return <LoadingIcon text={"Loading..."} />;
  }

  return (
    <>
      {boardBin !== null &&
      inventoryBin &&
      inventoryBin.flashpcb_bin_barcode === boardBin.flashpcb_bin_barcode ? (
        `${panelHeader} in board tote`
      ) : inventoryBin ? (
        <VerticalList>
          {panelHeader}
          <FlashPCBTooltip
            content={
              <BinInfo
                binName={inventoryBin.bin_name}
                binLocation={inventoryBin.bin_location}
                binBarcode={inventoryBin.flashpcb_bin_barcode}
                binType={inventoryBin.bin_type}
                canAllocateFromBin={inventoryBin.can_allocate_from_this_bin}
                forTooltip
              />
            }
          >
            <ItemLocationDetails>
              <>Panel location </>
              <InfoIcon />
            </ItemLocationDetails>
          </FlashPCBTooltip>
        </VerticalList>
      ) : (
        `${panelHeader} ${panel.flashpcb_bin_barcode === null || cannotFindBin ? "not associated with a bin" : ""}`
      )}
      {panelActions}
      {updatePanel && (
        <Modal isOpen={updatePanel} onRequestClose={closeModal}>
          <ModalContentWithCloseButton closeModal={closeModal}>
            <AddOrUpdateInventoryItem
              itemType={InventoryItemType.PANELS}
              itemToUpdate={panel}
              onCancel={closeModal}
              onSuccess={onSuccessfullyUpdatedPanel}
              boardId={boardId}
            />
          </ModalContentWithCloseButton>
        </Modal>
      )}
    </>
  );
}
